<template>
  <div class="alert alert-success border-success">
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="mb-3">
      <div class="h4 fw-bold">Analytics</div>
      <div class="fst-italic">Filter survey completion analytics by date</div>
      <div class="row text-start">
        <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
          <div class="fw-bold mt-1">
            Entries for {{ startDate }} - {{ endDate }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
          <input
            type="date"
            class="form-control"
            :value="startDate"
            @input="updateStartDate($event.target.value)"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
          <input
            type="date"
            class="form-control"
            :value="endDate"
            @input="updateEndDate($event.target.value)"
          />
        </div>
      </div>
      <div class="row text-start my-1">
        <div class="col-sm-12 col-md-12 col-lg-4 mb-3">
          <button class="btn btn-outline-secondary me-2" @click="addDays(-7)">
            &larr; Previous Week
          </button>
          <button class="btn btn-outline-primary" @click="addDays(7)">
            Next Week &rarr;
          </button>
        </div>
      </div>

      <div class="row text-start mt-4">
        <div class="col">
          <div class="h5">Total Began: {{ totalBegan }}</div>
          <div class="h5">Total Completed: {{ totalCompleted }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventAPI from "@/helpers/EventAPI";
import { mapGetters } from "vuex";
export default {
  name: "AdminDisplayAnalytics",
  mixins: [EventAPI],
  data() {
    const today = new Date();
    const sevenDaysLater = new Date();
    sevenDaysLater.setDate(today.getDate() + 7);
    return {
      isLoading: false,
      startDate: new Date().toISOString().split("T")[0],
      endDate: sevenDaysLater.toISOString().split("T")[0]
    };
  },
  computed: {
    ...mapGetters(["getAdminAnalytics"]),
    // Convert timestamps to date objects and filter by the selected date range
    filteredEntries() {
      // Convert startDate and endDate from YYYY-MM-DD format to a full date with time
      const start = new Date(`${this.startDate}T00:00:00`).getTime();
      const end = new Date(`${this.endDate}T23:59:59`).getTime();

      return this.getAdminAnalytics?.filter((entry) => {
        const entryTime = parseInt(entry.timestamp) * 1000; // Convert from seconds to milliseconds
        return entryTime >= start && entryTime <= end;
      });
    },
    uniqueSessions() {
      const sessionMap = new Map();

      this.filteredEntries.forEach((entry) => {
        if (!sessionMap.has(entry.session_id)) {
          sessionMap.set(entry.session_id, { began: false, completed: false });
        }
        const sessionData = sessionMap.get(entry.session_id);
        if (entry.event_name === "Began") {
          sessionData.began = true;
        } else if (entry.event_name === "Completed") {
          sessionData.completed = true;
        }
        sessionMap.set(entry.session_id, sessionData);
      });

      return Array.from(sessionMap.values());
    },
    totalBegan() {
      return this.uniqueSessions.filter((session) => session.began).length;
    },
    totalCompleted() {
      return this.uniqueSessions.filter((session) => session.completed).length;
    }
  },
  methods: {
    updateStartDate(date) {
      this.startDate = date;
    },
    updateEndDate(date) {
      this.endDate = date;
    },
    // Adjust the date range
    addDays(days) {
      const newStartDate = new Date(this.startDate);
      newStartDate.setDate(newStartDate.getDate() + days);

      const newEndDate = new Date(this.endDate);
      newEndDate.setDate(newEndDate.getDate() + days);

      this.startDate = newStartDate.toISOString().split("T")[0];
      this.endDate = newEndDate.toISOString().split("T")[0];
    }
  },
  created() {
    this.readContentEntries();
  },
  getAdminAnalytics: {
    handler(newVal) {
      if (newVal) {
        console.log(this.getAdminAnalytics);
      }
    },
    deep: true
  }
};
</script>

<style scoped></style>
